import DefaultModal from 'react-modal'
import './style.scss'
import Icon from '../ui/icon/Icon'

import { useEffect, memo } from 'react'

function Modal(props) {
    const { children, title, onClose, subtitle, svgIcon, success } = props

    useEffect(() => {
        const callback = (ev) => {
            if (ev.key === 'Escape') {
                onClose()
            }
        }
        document.addEventListener('keydown', callback, { capture: true })
        return () => document.removeEventListener('keydown', callback)
    }, [])

    const onOpenCallback = (props) => {
        if (props) {
            const { overlayEl, contentEl } = props
            overlayEl.addEventListener('mousedown', (ev) => {
                if (overlayEl === ev.target || contentEl === ev.target) {
                    onClose()
                }
            })
        }
    }

    return (
        <DefaultModal
            className={'modal'}
            id={title}
            shouldCloseOnEsc={true}
            shouldCloseOnOverlayClick={false}
            onAfterOpen={onOpenCallback}
            overlayClassName={'overlay'}
            center={true}
            {...props}
        >
            <div className="modal-dialog">
                {svgIcon && <div className="modal-dialog__icon" dangerouslySetInnerHTML={{ __html: svgIcon }}></div>}
                {title && <div className="modal-dialog__title">{title}</div>}
                <div className="modal-dialog__close" onClick={() => onClose()}>
                    <Icon name="i-close"></Icon>
                </div>
                <div className="modal-body">{children}</div>
            </div>
        </DefaultModal>
    )
}

export default memo(Modal)
